import { Box, IconButton as MuiIconButton, IconButtonProps, Tooltip, TooltipProps, useTheme } from "@mui/material";
import { RefObject, useMemo } from "react";
import { ButtonProps, useTranslate } from "react-admin";

export type EdmIconButtonPropsType = IconButtonProps & {
  tooltipTitle?: string;
  tooltipPlacement?: TooltipProps["placement"];
  tooltipArrow?: boolean;
  smartCount?: number;
  passedRef?: RefObject<HTMLButtonElement> | null;
  variant?: ButtonProps["variant"];
};

export default function EdmIconButton({
  children,
  color = "primary",
  variant = "contained",
  tooltipTitle,
  tooltipPlacement = "bottom",
  tooltipArrow = true,
  smartCount = 1,
  passedRef = null,
  sx = {},
  size = "small",
  ...props
}: EdmIconButtonPropsType) {
  const translate = useTranslate();
  const theme = useTheme();

  const finalTooltipTitle = useMemo(() => {
    return tooltipTitle ? translate(tooltipTitle, { smart_count: smartCount }) : "";
  }, [tooltipTitle, smartCount, translate]);

  const sxMemo = useMemo(() => {
    const defaultSx = {
      "& > svg": {
        position: "absolute",
      },
    };

    return variant === "text"
      ? {
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: theme.palette.bg.light,
          },
          ...defaultSx,
        }
      : defaultSx;
  }, [variant]);

  return (
    <Tooltip arrow={tooltipArrow} placement={tooltipPlacement} title={finalTooltipTitle}>
      <Box sx={sx} component="span" className="icon-button-container">
        <MuiIconButton size={size} color={color} sx={sxMemo} ref={passedRef} {...props}>
          {children}
        </MuiIconButton>
      </Box>
    </Tooltip>
  );
}
